export default "__VITE_ASSET__CLNbNevJ__"